import { render } from "./PasswordResetMain.vue?vue&type=template&id=41bb6f00&scoped=true&ts=true"
import script from "./PasswordResetMain.vue?vue&type=script&lang=ts"
export * from "./PasswordResetMain.vue?vue&type=script&lang=ts"

import "./PasswordResetMain.vue?vue&type=style&index=0&id=41bb6f00&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bb6f00"]])

export default __exports__